import { AjvError } from "@rjsf/core"
import { utils } from "@rjsf/core"


export const getUiOptions = utils.getUiOptions;
/**
 * Generates rows from JSONSchema object
 * @param schema 
 * @param getLabel 
 */
export const schemaToRows = (schema: any, getLabel: (subSchema: any) => string = (schema) => schema.title) => {
    const propertyKeys = schema.properties && Object.keys(schema.properties);
    if (!propertyKeys) return;

    return propertyKeys.map((propName: string) => {
        let propSchema = (schema as any).properties[propName];
        return { value: propName, text: getLabel(propSchema) || propName }
    })
}


function findVal(object: any, key: string): string | undefined {
    var value;
    Object.keys(object).some(function (k) {
        if (k === key) {
            value = object[k];
            return true;
        }
        if (object[k] && typeof object[k] === 'object') {
            value = findVal(object[k], key);
            return value !== undefined;
        }
    });
    return value;
}


export const uiSchemaToStaticErrors = (uiSchema: { [key: string]: any }): AjvError[] => {
    let errors: AjvError[] = [];

    for (var key in uiSchema) {
        if (typeof uiSchema[key] === "object") {
            const staticError = findVal(uiSchema[key], '_StaticValidationError')
            if (staticError) {
                errors.push({
                    message: staticError,
                    name: "staticError",
                    params: { missingProperty: key },
                    property: `.${key}`,
                    stack: `.${key} ${staticError}`
                })
            }
        }
    }

    return errors;
}



export const gatherStaticErrorsFromUiSchema = async (uiSchema: { [key: string]: any }): Promise<string[][]> => {
    let errs: string[][] = []
    await new Promise((resolve) => {
        for (var key in uiSchema) {
            if (typeof uiSchema[key] === "object") {
                const staticError = findVal(uiSchema[key], '_StaticValidationError')
                if (staticError) {
                    errs.push([key, staticError])
                }
            }
        }
        //@ts-ignore
        resolve();
    })

    return errs
}
